import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from '../components/Footer';
import MobileTabBar, { tabsForRole } from '../components/MobileTabBar';
import DpaConsentGate from '../components/DpaConsentGate';
import { useAuth } from '../AuthContext';
import styles from './RootLayout.module.css'
import { cssTransition, ToastContainer } from 'react-toastify';
import { useResponsive } from '../hooks/useResponsive';

const RootLayout = () => {
  const { isMobile } = useResponsive();
  const { isLoggedIn, userRole } = useAuth();
  // Tab-Leiste (UX-Plan 5.1): nur mobil und nur für Rollen mit Tabs (Lehrende, Studierende).
  const showTabBar = isMobile && isLoggedIn && tabsForRole(userRole).length > 0;

  // Globales CSS (index.css) richtet SaveBar, Footer, Toasts und schwebende Elemente
  // an der Leiste aus – analog zu body[data-savebar].
  useEffect(() => {
    if (showTabBar) document.body.setAttribute('data-tabbar', '1');
    else document.body.removeAttribute('data-tabbar');
    return () => document.body.removeAttribute('data-tabbar');
  }, [showTabBar]);
  const toastFades = cssTransition({
    enter: styles.toastEnter,
    exit: styles.toastExit,
    appendPosition: false,
    collapse: false,
    collapseDuration: 300,
  });

  return (
    <div className={styles.rootDiv}>
      <Navbar tabBarMode={showTabBar} />
      <main className={styles.mainContent}>
        <Outlet />
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={isMobile}
          pauseOnHover={false}
          theme="light"
          transition={toastFades}
        />
      </main>
      <Footer />
      {showTabBar && <MobileTabBar />}
      <DpaConsentGate />
    </div>
  );
};

export default RootLayout;
